import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { HeroTestimonials } from './components/HeroTestimonials';
import { PainPoints } from './components/PainPoints';
import { ProductPresentation } from './components/ProductPresentation';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { EliteDetails } from './components/EliteDetails';
import { ComparisonTable } from './components/ComparisonTable';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecentPurchasePopup } from './components/RecentPurchasePopup';
import { MetaPixelTracker } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-offwhite font-sans selection:bg-clay-orange selection:text-white" data-id="element-0">
      <MetaPixelTracker data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProofBar data-id="element-3" />
      <HeroTestimonials data-id="element-4" />
      <PainPoints data-id="element-5" />
      <ProductPresentation data-id="element-6" />
      <Tomos data-id="element-7" />
      <Bonuses data-id="element-8" />
      <Pricing data-id="element-9" />
      <EliteDetails data-id="element-10" />
      <ComparisonTable data-id="element-11" />
      <Testimonials data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <Footer data-id="element-16" />
      <RecentPurchasePopup data-id="element-17" />
    </div>;
}